import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../../../core/services/service.service';
import { MatDialog } from '@angular/material/dialog';
import { GlobalConstants } from 'src/app/common/global-constants';

@Component({
  selector: 'app-doctor-patient',
  templateUrl: './doctor-patient.component.html',
  styleUrls: ['./doctor-patient.component.scss']
})
export class DoctorPatientComponent implements OnInit {
  imageUrl1: string = GlobalConstants.imageUrl1;
  imageUrl2: string = GlobalConstants.imageUrl2;
  idOperatorAdmin : any;
  resultDataFavorite: any = [];
  resultDataNoFavorite: any = [];
  resultDataBackUp: any = [];
  resultDataDoctorMall: any;
  selected = '20';
  selectedFavorite = 'allFavorite';
  status: string = "all"
  loadDataUser: boolean = true;
  tableShow: boolean = false;
  cardShow: boolean = false;
  noDataInformation: boolean = false;
  favorite: boolean = false;
  noFavorite: boolean = false;
  allFavorite: boolean = true;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private ServiceService: ServiceService
  ) {
    this.idOperatorAdmin = localStorage.getItem("currentIdAdmin");
  }

  ngOnInit(): void {
    this.loadDataDoctorMall("StartTreat", this.status, this.selected,this.idOperatorAdmin);
  }

  onClickRefresh() {
    this.loadDataUser = true;
    this.tableShow = false;
    this.cardShow = false;
    this.loadDataDoctorMall("StartTreat", this.status, this.selected,this.idOperatorAdmin);
  }

  onChangeCountItem(event: string) {
    this.loadDataUser = true;
    this.tableShow = false;
    this.cardShow = false;

    this.resultDataDoctorMall = [];
    // console.log(event);
    this.selected = event;
    this.loadDataDoctorMall("StartTreat", this.status, this.selected,this.idOperatorAdmin);
  }

  onChangeFavorite(event: string) {
    this.loadDataUser = true;
    this.tableShow = false;
    this.cardShow = false;
    // console.log(event);
    this.resultDataDoctorMall = [];

    if (event == "noFavorite") {
      this.resultDataDoctorMall = this.resultDataNoFavorite;
      this.favorite = false;
      this.noFavorite = true;
      this.allFavorite = false;
    } else if (event == "favorite") {
      this.resultDataDoctorMall = this.resultDataFavorite;
      this.favorite = true;
      this.noFavorite = false;
      this.allFavorite = false;
    } else {
      this.resultDataDoctorMall = this.resultDataBackUp;
      this.favorite = false;
      this.noFavorite = false;
      this.allFavorite = true;
    }

    if (this.resultDataDoctorMall.length != 0) {
      setTimeout(() => {
        this.noDataInformation = false;
        this.loadDataUser = false;
        this.tableShow = true;
        this.cardShow = false;
      }, 2000);
    } else {
      setTimeout(() => {
        this.noDataInformation = true;
        this.loadDataUser = false;
        this.tableShow = true;
        this.cardShow = false;
      }, 2000);
    }
  }

  onChangeStatus(status: string) {
    this.loadDataUser = true;
    this.tableShow = false;
    this.cardShow = false;

    this.resultDataDoctorMall = [];
    if (status == "red") {
      this.status = "Red";
    } else if (status == "yellow") {
      this.status = "Yellow";
    } else if (status == "green") {
      this.status = "Green";
    } else {
      this.status = "all";
    }
    this.loadDataDoctorMall("StartTreat", this.status, this.selected,this.idOperatorAdmin);
  }

  onClickShowData(type: string) {
    this.loadDataUser = true;
    this.tableShow = false;
    this.cardShow = false;
    if (type == "card") {
      setTimeout(() => {
        this.loadDataUser = false;
        this.tableShow = false;
        this.cardShow = true;
      }, 2000);
    } else {
      setTimeout(() => {
        this.loadDataUser = false;
        this.tableShow = true;
        this.cardShow = false;
      }, 2000);
    }
  }

  loadDataDoctorMall(status: string, codivStatus: string, countLists: string,operatorAdminID: string) {
    this.loadData(status, codivStatus, countLists,operatorAdminID).then(resultDaTa => {
      this.resultDataDoctorMall = [];
      this.resultDataBackUp = [];
      this.resultDataFavorite = [];
      this.resultDataNoFavorite = [];
      // console.log("resDoctorMall ", resultDaTa);
      if (resultDaTa != false) {
        for (let i = 0; i < resultDaTa.length; i++) {
          if (resultDaTa[i].dpFavorite == true) {
            this.resultDataFavorite.push(resultDaTa[i])
          } else {
            this.resultDataNoFavorite.push(resultDaTa[i])
          }
        }
        if(this.favorite == true){
          this.resultDataDoctorMall = this.resultDataFavorite;
        }else if(this.noFavorite == true){
          this.resultDataDoctorMall = this.resultDataNoFavorite;
        }else if(this.allFavorite == true){
          this.resultDataDoctorMall = resultDaTa;
        }
        this.resultDataBackUp = resultDaTa;
        setTimeout(() => {
          this.noDataInformation = false;
          this.loadDataUser = false;
          this.tableShow = true;
          this.cardShow = false;
        }, 2000);
      } else {
        setTimeout(() => {
          this.noDataInformation = true;
          this.loadDataUser = false;
          this.tableShow = true;
          this.cardShow = false;
        }, 2000);
      }
    });
  }

  async loadData(status: string, codivStatus: string, countLists: string,operatorAdminID: string) {
    return new Promise<any>(async (resolve, rejects) => {
      var dataDoctorMall_: any;
      await this.ServiceService.GetDataDoctorMallList_(status, codivStatus, countLists,operatorAdminID).then(resDoctorMall => {
        dataDoctorMall_ = resDoctorMall;
        if (dataDoctorMall_.length != 0) {
          resolve(dataDoctorMall_);
        } else {
          resolve(false);
        }
      });

    });
  }

  onClickFavorite(idPatient: string, docCovidStatus: string, favorite: boolean) {
    this.ServiceService.UpdateDocCovidStatusAndFavorite_(idPatient, docCovidStatus, favorite).then(resUpdateDocCovidStatusAndFavorite => {
      // console.log(this.resultDataDoctorMall);
      for (let i = 0; i < this.resultDataDoctorMall.length; i++) {
        if (this.resultDataDoctorMall[i].dpPatientId == idPatient) {
          this.resultDataDoctorMall[i].dpFavorite = favorite;
        }
      }

    });
  }

  onChangeSymptomCovid(event: string,userId_:string) {
    for (let i = 0; i < this.resultDataDoctorMall.length; i++) {
      if (this.resultDataDoctorMall[i].userId == userId_) {
        this.resultDataDoctorMall[i].dpDocCovidStatus = event;
        this.ServiceService.UpdateDocCovidStatusAndFavorite_(userId_, event, this.resultDataDoctorMall[i].dpFavorite).then(resUpdateDocCovidStatusAndFavorite => {
          // console.log(resUpdateDocCovidStatusAndFavorite);
        });
      }
    }
  }

}
